import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { localDateFormatDays, localTimeFormat } from '../helper/dateFormat';

const style = {
  textAlign: 'right'
};

class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: null
    };
  }

  componentWillMount() {
    this.setState({
      timezone: this.props.timezone
    });
  }

  componentDidMount() {
    this.setDateTime();
    this.startInterval();
  }

  startInterval = () => {
    const intervalId = setInterval(this.setDateTime, 5000);
    this.setState({
      intervalId: intervalId
    });
  };

  clearInterval = () => {
    clearInterval(this.state.intervalId);
    this.setState({
      intervalId: null
    });
  };

  componentWillUnmount() {
    this.clearInterval();
  }

  componentWillReceiveProps(nextProps) {
    const { timezone } = nextProps;

    const timezoneChanged = timezone !== this.props.timezone;
    if (timezoneChanged) {
      this.setState({
        timezone: timezone
      });

      this.setDateTime();
    }
  }

  setDateTime = () => {
    const { timezone } = this.state;
    this.setState({
      siteDate: localDateFormatDays({ timezone }).format(new Date()),
      siteTime: localTimeFormat({ timezone }).format(new Date())
    });
  };

  render() {
    const { timezone, siteDate, siteTime } = this.state;

    return (
      <div style={style}>
        {siteDate && siteTime ? `${siteDate} - ${siteTime}` : null}{' '}
        {timezone
          ? moment.tz(timezone).format('z')
          : moment.tz(moment.tz.guess()).format('z')}
      </div>
    );
  }
}

Timer.propTypes = {
  timezone: PropTypes.string
};

export default Timer;



// WEBPACK FOOTER //
// ./src/components/Timer.js